import MapperBase from '../MapperBase.js';
import { ChartSeries } from '../../entities/index.js';

class PlotlySeriesMapperBase extends MapperBase {
    constructor(silent, fallback, traceTemplate, requiredSeriesDimension) {
        super(silent, fallback);

        if (typeof(traceTemplate) !== 'undefined') {
            if (typeof(traceTemplate) !== 'object') {
                throw new TypeError('traceTemplate must be an object');
            }

            this.traceTemplate = traceTemplate;
        }
        else {
            this.traceTemplate = {};
        }

        if (typeof(requiredSeriesDimension) !== 'undefined') {
            if (!Number.isInteger(requiredSeriesDimension) || requiredSeriesDimension < 1) {
                throw new TypeError('requiredSeriesDimension must be integer greater than 0');
            }
        }

        this.requiredSeriesDimension = requiredSeriesDimension;
        this.dimensionsMapping = [];
    }

    defineDimensionsMapping(dimensionNr, traceProperty) {
        return this.dimensionsMapping[traceProperty] = dimensionNr;
    }

    map(item) {
        if (!(item instanceof ChartSeries)) {
            throw new TypeError('item must be an instance inheriting from ChartSeries class');
        }

        const traces = [];

        for (let i = 0; i < item.length; i++) {
            const series = item[i];
            if (!this.checkDimensions(item, series)){
                throw new Error(`only ${this.requiredSeriesDimension} dimensional series are supported`);
            }

            let trace = this.createTrace(item, series);
            this.mapDimensionsToProperties(trace, item, series);
            trace = this.formatTrace(trace, i, item, series);

            traces.push(trace);
        }

        return this.formatTraces(traces, item);
    }

    checkDimensions(chartSeries, series) {
        if (this.requiredSeriesDimension && series.dimensions !== this.requiredSeriesDimension){
            return false;
        }

        return true;
    }

    createTrace(chartSeries, series) {
        return Object.assign({}, this.traceTemplate);
    }

    mapDimensionsToProperties(trace, chartSeries, series) {
        for (const property in this.dimensionsMapping) {
            if (!this.dimensionsMapping.hasOwnProperty(property)) {
                continue;
            }

            const dimensionNr = this.dimensionsMapping[property];
            trace[property] = series.getDimension(dimensionNr);
        }
    }

    formatTraces(traces, chartSeries) {
        return traces;
    }

    formatTrace(trace, traceIndex, chartSeries, series) {
        // https://plotly.com/javascript/reference/#scatter-customdata
        trace.customdata = series.getSources();
        // https://plotly.com/javascript/reference/#scatter-name
        trace.name = series.name;
        trace.key = series.name;

        return trace;
    }
}

export default PlotlySeriesMapperBase;